import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/Search.vue')
  },
  {
    path: '/models',
    name: 'Models',
    redirect: { name: 'Search' }
  },
  {
    path: '/models/feihong',
    name: 'ModelsFeihong',
    component: () => import('@/views/ModelsFeihong.vue')
  },
  {
    path: '/models/ketianshi',
    name: 'ModelsKetianshi',
    component: () => import('@/views/ModelsKetianshi.vue')
  },
  {
    path: '/models/amplifier',
    name: 'ModelsAmplifier',
    component: () => import('@/views/ModelsAmplifier.vue')
  },
  {
    path: '/models/comparator',
    name: 'ModelsComparator',
    component: () => import('@/views/ModelsComparator.vue')
  },
  {
    path: '/models/special',
    name: 'ModelsSpecial',
    component: () => import('@/views/ModelsSpecial.vue')
  },
  {
    path: '/models/sensor-monitoring-afe',
    name: 'ModelsSensorMonitoringAfe',
    component: () => import('@/views/ModelsSensorMonitoringAfe.vue')
  },
  {
    path: '/models/data-converter',
    name: 'ModelsDataConverter',
    component: () => import('@/views/ModelsDataConverter.vue')
  },
  {
    path: '/models/ldo-linear-regulator',
    name: 'ModelsLDOLinearRegulator',
    component: () => import('@/views/ModelsLDOLinearRegulator.vue')
  },
  {
    path: '/models/dcdc-switching-regulator',
    name: 'ModelsDCDCSwitchingRegulator',
    component: () => import('@/views/ModelsDCDCSwitchingRegulator.vue')
  },
  {
    path: '/models/pmics',
    name: 'ModelsPMICs',
    component: () => import('@/views/ModelsPMICs.vue')
  },
  {
    path: '/models/io-link',
    name: 'ModelsIOLink',
    component: () => import('@/views/ModelsIOLink.vue')
  },
  {
    path: '/models/switching-drivers-gate',
    name: 'ModelsSwitchingDriversGate',
    component: () => import('@/views/ModelsSwitchingDriversGate.vue')
  },
  {
    path: '/models/switching-drivers-half',
    name: 'ModelsSwitchingDriversHalf',
    component: () => import('@/views/ModelsSwitchingDriversHalf.vue')
  },
  {
    path: '/models/switching-drivers-wboost',
    name: 'ModelsSwitchingDriversWboost',
    component: () => import('@/views/ModelsSwitchingDriversWboost.vue')
  },
  {
    path: '/models/switching-ics',
    name: 'ModelsSwitchingICs',
    component: () => import('@/views/ModelsSwitchingICs.vue')
  },
  {
    path: '/models/shunt-regulators',
    name: 'ModelsShuntRegulators',
    component: () => import('@/views/ModelsShuntRegulators.vue')
  },
  {
    path: '/models/charge-pumps',
    name: 'ModelsChargePumps',
    component: () => import('@/views/ModelsChargePumps.vue')
  },
  {
    path: '/models/ssfm-oscillator',
    name: 'ModelsSsfm',
    component: () => import('@/views/ModelsSsfm.vue')
  },
  {
    path: '/models/led-controller',
    name: 'ModelsLEDController',
    component: () => import('@/views/ModelsLEDController.vue')
  },
  {
    path: '/models/voltage-detector',
    name: 'ModelsVoltageDetector',
    component: () => import('@/views/ModelsVoltageDetector.vue')
  },
  {
    path: '/models/reset-timer',
    name: 'ModelsResetTimer',
    component: () => import('@/views/ModelsResetTimer.vue')
  },
  {
    path: '/models/li-ion-battery',
    name: 'ModelsLiIonBattery',
    component: () => import('@/views/ModelsLiIonBattery.vue')
  },
  {
    path: '/models/battery-charger',
    name: 'ModelsBatteryCharger',
    component: () => import('@/views/ModelsBatteryCharger.vue')
  },
  {
    path: '/models/battery-backup',
    name: 'ModelsBatteryBackup',
    component: () => import('@/views/ModelsBatteryBackup.vue')
  },
  {
    path: '/models/mems-transducer',
    name: 'ModelsMemsTransducer',
    component: () => import('@/views/ModelsMemsTransducer.vue')
  },
  {
    path: '/models/mems-microphone-amplifiers',
    name: 'ModelsMemsMicrophoneAmplifiers',
    component: () => import('@/views/ModelsMemsMicrophoneAmplifiers.vue')
  },
  {
    path: '/models/audio-amplifier',
    name: 'ModelsAudioAmplifier',
    component: () => import('@/views/ModelsAudioAmplifier.vue')
  },
  {
    path: '/models/audio-signal-processor',
    name: 'ModelsAudioSignalProcessor',
    component: () => import('@/views/ModelsAudioSignalProcessor.vue')
  },
  {
    path: '/models/audio-switch',
    name: 'ModelsAudioSwitch',
    component: () => import('@/views/ModelsAudioSwitch.vue')
  },
  {
    path: '/models/video-ic',
    name: 'ModelsVideoIC',
    component: () => import('@/views/ModelsVideoIC.vue')
  },
  {
    path: '/models/audio-video-misc',
    name: 'ModelsAudioVideoMisc',
    component: () => import('@/views/ModelsAudioVideoMisc.vue')
  },
  {
    path: '/models/rf-switch',
    name: 'ModelsRFSwitch',
    component: () => import('@/views/ModelsRFSwitch.vue')
  },
  {
    path: '/models/low-noise-amplifier',
    name: 'ModelsLowNoiseAmplifier',
    component: () => import('@/views/ModelsLowNoiseAmplifier.vue')
  },
  {
    path: '/models/saw-filter',
    name: 'ModelsSAWFilter',
    component: () => import('@/views/ModelsSAWFilter.vue')
  },
  {
    path: '/models/fm-if-demodulator',
    name: 'ModelsFMIFDemodulator',
    component: () => import('@/views/ModelsFMIFDemodulator.vue')
  },
  {
    path: '/models/amplifier-pll',
    name: 'ModelsAmplifierPLL',
    component: () => import('@/views/ModelsAmplifierPLL.vue')
  },
  {
    path: '/models/modulation-demodulation-mixer',
    name: 'ModelsModulationDemodulationMixer',
    component: () => import('@/views/ModelsModulationDemodulationMixer.vue')
  },
  {
    path: '/models/stepper-motor-driver',
    name: 'ModelsStepperMotorDriver',
    component: () => import('@/views/ModelsStepperMotorDriver.vue')
  },
  {
    path: '/models/three-phase-bldc',
    name: 'ModelsThreePhaseBLDC',
    component: () => import('@/views/ModelsThreePhaseBLDC.vue')
  },
  {
    path: '/models/single-phase-bldc',
    name: 'ModelsSinglePhaseBLDC',
    component: () => import('@/views/ModelsSinglePhaseBLDC.vue')
  },
  {
    path: '/models/actuator-gate-drivers',
    name: 'ModelsActuatorGateDrivers',
    component: () => import('@/views/ModelsActuatorGateDrivers.vue')
  },
  {
    path: '/models/real-time-clock',
    name: 'ModelsRealTimeClock',
    component: () => import('@/views/ModelsRealTimeClock.vue')
  },
  {
    path: '/models/quartz-crystal-oscillator',
    name: 'ModelsQuartzCrystalOscillator',
    component: () => import('@/views/ModelsQuartzCrystalOscillator.vue')
  },
  {
    path: '/models/ate-assps',
    name: 'ModelsATEAssps',
    component: () => import('@/views/ModelsATEAssps.vue')
  },
  {
    path: '/models/lcd-drivers',
    name: 'ModelsLCDDrivers',
    component: () => import('@/views/ModelsLCDDrivers.vue')
  },
  {
    path: '/models/ld-driver-ics',
    name: 'ModelsLDDriverICs',
    component: () => import('@/views/ModelsLDDriverICs.vue')
  },
  {
    path: '/models/analog-switches',
    name: 'ModelsAnalogSwitches',
    component: () => import('@/views/ModelsAnalogSwitches.vue')
  },
  {
    path: '/models/io-port-expansion',
    name: 'ModelsIOPortExpansion',
    component: () => import('@/views/ModelsIOPortExpansion.vue')
  },
  {
    path: '/models/other-peripheral-ics',
    name: 'ModelsOtherPeripheralICs',
    component: () => import('@/views/ModelsOtherPeripheralICs.vue')
  },
  {
    path: '/agent-brands',
    name: 'AgentBrands',
    component: () => import('@/views/AgentBrands.vue')
  },
  {
    path: '/dealer-brands',
    name: 'DealerBrands',
    component: () => import('@/views/DealerBrands.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '/news',
    name: 'NewsList',
    component: () => import('@/views/NewsList.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router 